import css from "styled-jsx/css";

export default css`
  .support-fake {
    width: 100%;
    margin-left: 0;
    &--container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      &--box-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      &--box {
        width: 100%;
      }
    }
    &--footer {
      height: 150px;
      width: 100%;
    }
  }

  @media (min-width: 768px) {
    .support-fake {
      width: 60%;
    }
  }
`;
